import { Card, CardContent, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import React, { Component } from "react";
import { Table } from "react-bootstrap";
import AppConfig from "../../../../config/AppConfig";
import ChartSebaranPelaporanBerdasarkanJenisA from "./component/ChartSebaranPelaporanBerdasarkanJenisA";
import ChartSebaranPelaporanBerdasarkanJenisB from "./component/ChartSebaranPelaporanBerdasarkanJenisB";
import ChartSebaranPelaporanBerdasarkanWilayah from "./component/ChartSebaranPelaporanBerdasarkanWilayah";
class SebaranPelaporan extends Component {
  state = {
    lembaga: "1",
    status: false,
    loading1: false,
    loading2: false,
    data_loaded1: false,
    data_loaded2: false,
    data_chart1: [],
    data_chart2: [],
    // total_data1: [],
    total_data2: [],
  };
  onChangeMenu = (e, type) => {
    this.setState({
      [type]: e.target.value,
      status: true,
    });
  };

  modifyStatus = (data) => {
    this.setState({ status: data });
  };

  // Get Data ============================================================================
  getDataChart1() {
    this.setState({
      loading1: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.get(AppConfig.DetailDashboard + "sebaranpelaporanbywilayah" + session)
      .then((res) => {
        // console.log(res.data.result.data);
        this.setState({
          loading1: false,
          data_loaded1: true,
          data_chart1: res.data.result.data,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  getDataChart2() {
    this.setState({
      loading2: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.get(AppConfig.DetailDashboard + "sebaranpelaporanbyjenis" + session)
      .then((res) => {
        console.log(res.data.result);
        this.setState({
          loading2: false,
          data_loaded2: true,
          data_chart2: res.data.result.data_vokasi,
          total_data2: res.data.result.data_belmawa,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getDataChart1();
    this.getDataChart2();
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let access = userdata.i_idbp;

    let i = 0;
    let list_data_chart1 = [];
    let list_data_chart2 = [];

    if (this.state.data_loaded1 === true) {
      for (var index in this.state.data_chart1) {
        list_data_chart1[i] = {
          result: this.state.data_chart1[index],
          key: index,
        };
        i++;
      }
      // console.log(list_data_chart1);
    }
    if (this.state.data_loaded2 === true) {
      if (access !== 2) {
        for (var index in this.state.total_data2) {
          list_data_chart2[i] = {
            result: this.state.total_data2[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart2);
      } else {
        for (var index in this.state.data_chart2) {
          list_data_chart2[i] = {
            result: this.state.data_chart2[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart2);
      }
    }

    return (
      <>
        <Card className="mt-10">
          <CardContent>
            <div className="row row-paddingless">
              <div
                className="col-md-12 col-xxl-12"
                style={{ textAlign: "center" }}
              >
                <h3
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Sebaran PTV Pelaporan SPMI
                </h3>
                <div className="row mb-5">
                  <div className="col-md-2 offset-md-5">
                    <select
                      name="display"
                      className={`form-control form-control-lg form-control-solid `}
                      style={{ paddingLeft: "0px 20px 0px 20px" }}
                      onChange={(e) => this.onChangeMenu(e, "lembaga")}
                    >
                      <option value="1">Kemendikbud</option>
                      <option value="2">Kementerian Luar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-xxl-6"
                style={{ textAlign: "center" }}
              >
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Rekap Sebaran Pelaporan Berdasarkan Wilayah PTV
                </h5>
                <ChartSebaranPelaporanBerdasarkanWilayah
                  tipe_lembaga={this.state.lembaga}
                  status={this.state.status}
                  parentCallback={this.modifyStatus}
                />
              </div>
              <div
                className="col-md-6 col-xxl-6"
                style={{ textAlign: "center" }}
              >
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Rekap Sebaran Pelaporan Berdasarkan Jenis PTV
                </h5>
                {access === 2 ? (
                  <ChartSebaranPelaporanBerdasarkanJenisA
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                ) : (
                  <ChartSebaranPelaporanBerdasarkanJenisB
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                )}
              </div>
              <br />
              <div
                className="col-md-6 col-xxl-6"
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                <div className={`card-custom`}>
                  {/* Body */}
                  <div className="card-body pt-2">
                    {/* Table Here */}
                    <Table responsive hover style={{ overflow: "auto" }}>
                      <thead
                        className="text-white"
                        style={{ backgroundColor: "#3047ad" }}
                      >
                        <tr>
                          <th
                            style={{
                              width: "20%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            Wilayah
                          </th>
                          <th
                            className="text-center"
                            style={{
                              width: "20%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            Belum Mengisi
                          </th>
                          <th
                            className="text-center"
                            style={{
                              width: "20%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            Belum Lengkap
                          </th>
                          <th
                            style={{
                              width: "20%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                            }}
                          >
                            Sudah Lengkap
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading1 === true ? (
                          <tr>
                            <td colSpan="4">
                              <LinearProgress
                                color="secondary"
                                variant="query"
                              />
                            </td>
                          </tr>
                        ) : this.state.data_loaded1 === true ? (
                          list_data_chart1.map((list) => (
                            <tr key={list.key}>
                              <td style={{ verticalAlign: "middle" }}>
                                <b>{list.key}</b>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {list.result.belum_mengisi}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {list.result.belum_lengkap}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {list.result.sudah_lengkap}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <>
                            <tr>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                <em>Data does not exist</em>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-xxl-6"
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                <div className={`card-custom`}>
                  {/* Body */}
                  <div className="card-body pt-2">
                    {/* Table Here */}
                    {access === 2 ? (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Jenis Organisasi
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Belum Mengisi
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Belum Lengkap
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Sudah Lengkap
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading2 === true ? (
                            <tr>
                              <td colSpan="4">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded2 === true ? (
                            list_data_chart2.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.belum_mengisi}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.belum_lengkap}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.sudah_lengkap}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            ></th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Belum Mengisi
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Belum Lengkap
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Sudah Lengkap
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading2 === true ? (
                            <tr>
                              <td colSpan="4">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded2 === true ? (
                            list_data_chart2.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.belum_mengisi}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.belum_lengkap}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.sudah_lengkap}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}
export default SebaranPelaporan;
